import * as xxhashjs from 'xxhashjs'
import { sortObjectKeys } from './object'
import * as blakejs from 'blakejs'

const { blake2bHex } = blakejs
const { h32, h64 } = xxhashjs

/**
 * Isomorphic hash function.
 */
export const hash = (input: string) => {
  return h32(input, 0xfff).toString(16)
}

export const hashNeue = (input: string) => {
  return h64(input, 0xf1db239a2).toString(16)
}

export const hashJson = (
  input: Parameters<typeof JSON.stringify>[0],
  debug?: boolean
) => {
  const now = debug ? performance.now() : undefined
  const sorted = sortObjectKeys(input)
  if (debug && now) {
    console.log(
      `[hashJson] [sortObjectKeys] time took ${performance.now() - now}ms`
    )
  }
  const result = hash(JSON.stringify(sorted))
  if (debug && now) {
    console.log(`[hashJson] [total] time took ${performance.now() - now}ms`)
  }
  return result
}

export const hashJsonNeue = (
  input: Parameters<typeof JSON.stringify>[0],
  debug?: boolean
) => {
  const now = debug ? performance.now() : undefined
  const sorted = sortObjectKeys(input)
  if (debug && now) {
    console.log(
      `[hashJsonNeue] [sortObjectKeys] time took ${performance.now() - now}ms`
    )
  }
  const result = hashNeue(JSON.stringify(sorted))
  if (debug && now) {
    console.log(`[hashJsonNeue] [total] time took ${performance.now() - now}ms`)
  }
  return result
}

export const hashRepoId = (repoId: string) => blake2bHex(repoId).slice(0, 8)

export const hashRepoIdForWorkerBalancer = (input: string) => {
  return h32(input, 0xfff).toNumber()
}
